// extracted by mini-css-extract-plugin
export default {"main":"Student_main__5BWv5","table":"Student_table__L0TK-","info":"Student_info__7Rtvz"};